<template>
  <div class="content">
    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <p-s-table
                title="Rollen und Berechtigungen"
                subTitle="von Firma Mustermann"
                v-bind:data="this.reports"
                v-bind:dict="this.reportsDict"
        ></p-s-table>
      </div>
    </div>
  </div>
</template>

<script>
import PSTable from "../components/Tables/PSTable";
import api from '@/api/api';
import store from '@/store/index.js';

export default {
  name: "RolesAndRights",
  components: {
    PSTable
  },
  data() {
    return {
      roles: [],
      rolesDict: [
        { key: 'mail', label: 'Email-Adresse', type: 'string'},
        { key: 'name', label: 'Bericht', type: 'string'}
      ]
    };
  },
  created () {
    store.commit("setLoading", true);

    api.getRoles().then((result) => {
      this.roles = result.data;

      store.commit("setLoading", false);
    });
  }
};
</script>

<style scoped>

</style>
